// extracted by mini-css-extract-plugin
export default {"pageSection":"PageSection_pageSection__C1mpB","grayBg":"PageSection_grayBg__dSqiX","contentWrapper":"PageSection_contentWrapper__vnYFr","title":"PageSection_title__wKILT"};